module.exports = __webpack_public_path__ + "static/media/top-img_3@2x.233e7103.png";